<div class="modal-message">
  @if (data.bodyText) {
    <div class="intro">{{data.bodyText}}</div>
  }
  @if (data.bodyHtml) {
    <div class="intro" [innerHTML]="sanitizedBody"></div>
  }
</div>
